module.exports = __webpack_public_path__ + "static/media/dopuszczenie-H.fdb15d1c.svg";